import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from '../../api/api';
import Swal from 'sweetalert2'
import { AUTH_CONFIG } from "../../auth/config";

const initialState = {
    user: null,
    loading: false,
    error: '',
}

export const loginAsync = createAsyncThunk('login', async({ username, password }, store) => {
    try {
        const user = await api.post(AUTH_CONFIG.requests.login.url, {
            usernameOrEmail: username,
            password: password,
        })
        if (user.data.code === 1000) {
            localStorage.setItem("accessTR", user.data.result.AccessToken);
            localStorage.setItem("refreshTR", user.data.result.RefreshToken);
            window.location.href = '/'
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'login failed',
            })
            
        }
        return user.data

    } catch (error) {
        throw error
    }
})


const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logout: (state, action) => {
            state.user = null
            state.loading = false
            state.error = ''
        }
    },
    extraReducers: {
        [loginAsync.pending]: (state, action) => {
            state.loading = true
            state.error = ''
        },
        [loginAsync.fulfilled]: (state, action) => {
            state.user = action.payload
            state.loading = false
            state.error = ''
        },
        [loginAsync.rejected]: (state, action) => {
            state.user = null
            state.loading = false
            state.error = action.error.message
        }
    },
})
export const { logout } = authSlice.actions
export default authSlice.reducer